/**
 * Format a phone number for display.
 * - 10-digit US numbers → (555) 123-4567
 * - 11-digit starting with 1 → +1 (555) 123-4567
 * - Null/empty → null
 * - Anything else → returned as-is
 */
export function formatPhone(phone: string | null | undefined): string | null {
  if (!phone) return null;

  const digits = phone.replace(/\D/g, '');

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  return phone;
}
